export default __webpack_public_path__ + "static/media/1129.ec32adac.png";